
import { useEffect } from "react";
import { storeCampaignCookie } from "./referralUtils";

export const usePhemexCampaign = () => {
  useEffect(() => {
    // This will run once when the component mounts
    storeCampaignCookie("phemex", 42); // Changed from default 365 days to 42 days (6 weeks)
    
    // Log for debugging
    console.log("Phemex campaign cookie set with 6 weeks expiration");
  }, []);
};
